import { render, staticRenderFns } from "./subprogram-nba-standings-table.vue?vue&type=template&id=69ff856e&scoped=true&"
import script from "./subprogram-nba-standings-table.vue?vue&type=script&lang=js&"
export * from "./subprogram-nba-standings-table.vue?vue&type=script&lang=js&"
import style0 from "./subprogram-nba-standings-table.vue?vue&type=style&index=0&id=69ff856e&lang=scss&scoped=true&"
import style1 from "./subprogram-nba-standings-table.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ff856e",
  null
  
)

export default component.exports